import { render, staticRenderFns } from "./staffHeader.vue?vue&type=template&id=2540cf36&scoped=true"
import script from "./staffHeader.vue?vue&type=script&lang=js"
export * from "./staffHeader.vue?vue&type=script&lang=js"
import style0 from "./staffHeader.vue?vue&type=style&index=0&id=2540cf36&prod&lang=scss&scoped=true"
import style1 from "./staffHeader.vue?vue&type=style&index=1&id=2540cf36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2540cf36",
  null
  
)

export default component.exports